// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2FviY","heading":"Header_heading__16tMF"};